// FE→BE seam for resending the identity email. Server counterpart:
// `app/api/resend-email-verification/route.ts`.
import { HTTP_STATUS } from "@/constants/http"

const RESEND_EMAIL_VERIFICATION_ENDPOINT = "/api/resend-email-verification"

export type ResendEmailVerificationResult =
  | { ok: true }
  | { ok: false; reason: "unauthorized" | "rate_limited" | "failed" }

export async function postResendEmailVerification(): Promise<ResendEmailVerificationResult> {
  const response = await fetch(RESEND_EMAIL_VERIFICATION_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" }
  })

  if (response.status === HTTP_STATUS.UNAUTHORIZED) {
    return { ok: false, reason: "unauthorized" }
  }

  if (response.status === HTTP_STATUS.TOO_MANY_REQUESTS) {
    return { ok: false, reason: "rate_limited" }
  }

  if (!response.ok) {
    return { ok: false, reason: "failed" }
  }

  return { ok: true }
}
